import { useTranslations } from '@react/lib/i18n';
import * as React from 'react';
import { FunctionComponent } from 'react';
import { FormDefinitionsContainer } from './FormDefinitionsPage.styled';

interface Props {
  clinicToken: string;
  language: string;
  formDesignerLoaded: boolean;
}

const FormDefinitionsPage: FunctionComponent<Props> = ({
  clinicToken,
  language,
  formDesignerLoaded
}) => {
  const { t } = useTranslations();

  if (!formDesignerLoaded) {
    return (
      <FormDefinitionsContainer>
        {t.Admin.FormsLoadingMessage || 'Loading forms...'}
      </FormDefinitionsContainer>
    );
  }

  return (
    <FormDefinitionsContainer>
      {React.createElement('salve-clinic-form-designer', {
        'clinic-token': clinicToken,
        language
      })}
    </FormDefinitionsContainer>
  );
};

export default FormDefinitionsPage;
